import api from "../index";

export const addUpdateAccountInformation = (data) => api.post("IndividualAccount/add-update-personalinfo", data);
export const addUpdateFinancialInfo = (data) => api.post("IndividualAccount/add-update-financialinfo", data);
export const addUpdateDeclaration = (data) => api.post("IndividualAccount/set-declarationinfo", data);
export const updateEkycStatus = (data) => api.put("IndividualAccount/update-ekyc-status", data);

export const getIndividualAccount = () => api.get("IndividualAccount/get-individual-account");
export const getPersonalInfo = (id) => api.get(`IndividualAccount/get-personalinfo/${id}`);
export const getFinancialInfo = (id) => api.get(`IndividualAccount/get-financialinfo/${id}`);
export const getDeclarationInfo = () => api.get(`IndividualAccount/get-declarationinfo`);

export const getIndustryTypes = () => api.get("IndividualAccount/industry-types");






